import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

export interface PassCodeLockGracePeriod {
  passCodeLockGracePeriod: number;
}

@Component({
  selector: 'ml-pass-code-lock-grace-period-ui',
  templateUrl: 'pass-code-lock-grace-period.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule],
})
export class ManagedSettingsPassCodeLockGracePeriodComponent {
  private readonly fb = inject(UntypedFormBuilder);
  private cd = inject(ChangeDetectorRef);

  readonly passCodeLockGracePeriod = output<PassCodeLockGracePeriod>();

  public readonly passCodeLockGracePeriodForm = this.fb.group({
    passCodeLockGracePeriod: [0, [Validators.min(0), Validators.max(14400)]],
  });

  onSubmit() {
    this.passCodeLockGracePeriod.emit(this.passCodeLockGracePeriodForm.value);
  }
}
